/**
 * Tiny pub/sub so the particle wave can tell the dashboard "a drop just hit the
 * surface". The SYNAPSE wordmark subscribes and lights its gradient outline on
 * each collision (it's off otherwise).
 */

type Listener = () => void;
const listeners = new Set<Listener>();

export function onWavePulse(fn: Listener): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function emitWavePulse(): void {
  listeners.forEach((fn) => {
    try { fn(); } catch { /* a bad listener must not break the wave loop */ }
  });
}
